"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var customerActions = require("@caddigital/sok-reducers/lib/actions/customer");
var Builder_1 = require("components/DashboardElements/Builder");
var Types = require("types");
var mapStateToProps = function (state) {
    return {
        dashboard: state.customer.dashboard,
        customerName: state.customer.wizard.customerName
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    fetch: function (customer) {
        return dispatch(customerActions.DashboardActions.fetchRequest('CUSTOMER', customer));
    },
    changeModalStatus: function (modal, status, item) {
        return dispatch(customerActions.DashboardActions.changeModalStatus(modal, status, item));
    },
    createDashboard: function (id, item) {
        return dispatch(customerActions.DashboardActions.createRequest('CUSTOMER', id, item));
    },
    updateDashboard: function (id, item) {
        return dispatch(customerActions.DashboardActions.editRequest('CUSTOMER', id, item));
    },
    removeDashboard: function (id, item) {
        return dispatch(customerActions.DashboardActions.removeRequest('CUSTOMER', id, item));
    },
    updateModalItem: function (key, value) {
        return dispatch(customerActions.DashboardActions.updateModalItem(key, value));
    },
    addElement: function (type) {
        return dispatch(customerActions.DashboardActions.addElement(type));
    },
    updateElement: function (index, key, value) {
        return dispatch(customerActions.DashboardActions.updateElement(index, key, value));
    },
    removeElement: function (index) {
        return dispatch(customerActions.DashboardActions.removeElement(index));
    },
    clear: function () { return dispatch(customerActions.DashboardActions.clear()); }
}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('DashboardElements'), (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentWillMount: function () {
        this.props.fetch(this.props.customerId);
    },
    componentDidUpdate: function (prevProps) {
        if (this.props.customerId !== prevProps.customerId ||
            (this.props.dashboard.status === 'STANDBY' &&
                this.props.dashboard.status !== prevProps.dashboard.status)) {
            this.props.fetch(this.props.customerId);
        }
    },
    componentWillUnmount: function () {
        this.props.clear();
    }
}), recompose_1.pure);
exports.default = enhance(function (props) { return (React.createElement("div", { className: 'customer-wizard-step2' },
    React.createElement(Builder_1.default, { dashboard: props.dashboard, parent: 'CUSTOMER', fetch: function () { return props.fetch(props.customerId); }, changeModalStatus: props.changeModalStatus, createDashboard: function (item) { return props.createDashboard(props.customerId, item); }, updateDashboard: function (item) { return props.updateDashboard(props.customerId, item); }, removeDashboard: function (item) { return props.removeDashboard(props.customerId, item); }, updateModalItem: props.updateModalItem, addElement: props.addElement, updateElement: props.updateElement, removeElement: props.removeElement, modalMessage: (0, translation_1.getLocalization)('dashboardElements/modal/text', [
            props.customerName || ''
        ]), starMessage: (0, translation_1.getLocalization)('dashboardElements/showText', [
            props.customerName || ''
        ]) }))); });
